export enum SettingsMode {
  EDIT = 'EDIT',
  READ = 'READ',
}
